import { Currency } from 'types'

/**
 * Utility function for getting the currency symbol using currency name.
 *
 * @param currency Currency
 * @returns
 */

const getCurrencySymbol = (currency: Currency) => {
	switch (currency) {
		case 'USD':
			return '$'
		case 'INR':
			return '₹'
		case 'EUR':
			return '€'
		case 'IDR':
			return 'Rp'
		case 'AUD':
			return 'A$'
		case 'GBP':
			return '£'
		default:
			return ''
	}
}

export default getCurrencySymbol
